import { fg } from '@atlaskit/platform-feature-flags/fg';
import {
	getLocalStorageItemAsString,
	setLocalStorageItem,
} from '@atlassian/search-common/local-storage';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { isVisited } from './is-visited';

const SEARCH_PAGE_VISITED_KEY = 'atlassian.search-page.visited';
const MAX_VISITED_LINKS = 1000;

export const addVisitedLink = (value: string): void => {
	if (fg('rovo_fps_limit_visited_history')) {
		const visitedLinks = getVisitedLinks();
		// Move repeat visits to the end so eviction keeps the most recently clicked IDs.
		visitedLinks.delete(value);
		visitedLinks.add(value);
		setLocalStorageItem(
			SEARCH_PAGE_VISITED_KEY,
			JSON.stringify([...visitedLinks].slice(-MAX_VISITED_LINKS)),
		);
		return;
	}

	setLocalStorageItem(SEARCH_PAGE_VISITED_KEY, JSON.stringify([...getVisitedLinks(), value]));
};

export const getVisitedLinks = (): Set<string> => {
	const visitedLinksRaw = getLocalStorageItemAsString(SEARCH_PAGE_VISITED_KEY);
	return new Set(visitedLinksRaw ? JSON.parse(visitedLinksRaw) : []);
};
